import React, { useEffect, useState } from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import { Logo } from "./svg-components/Logo";
import SearchBar from "./SearchBar";
import MobileSearchBar from "./MobileSearchBar";
import { MyCart } from "./MyCart";
import Nabh from "./svg-components/Nabh";
import { LuUser, LuShoppingCart } from "react-icons/lu";
import { PiShoppingCartSimple } from "react-icons/pi";
import { useData } from "../context/context";
import { Badge } from "@mui/material";
import { Facebook } from "./svg-components/Facebook";
import { LinkedIn } from "./svg-components/LinkedIn";
import { Instagram } from "./svg-components/Instagram";
import Upload from "./svg-components/Upload";
import AddPackages from "./svg-components/AddPackages";
import { Link, useLocation } from "react-router-dom";
import Download from "./svg-components/Download";

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { cartState, cartDispatch } = useData();

  const location = useLocation();
  const showSearchBar = location.pathname == "/";

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const menuClasses = `menslide${isMenuOpen ? " active" : ""}`;
  const hamburgerClasses = `hemburgur${isMenuOpen ? " active" : ""}`;

  useEffect(() => {
    Aos.init({ duration: 1000 });
    window.addEventListener("scroll", changeBackground);

    return () => {
      window.removeEventListener("scroll", changeBackground);
    };
  }, []);
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  const [header, setNavbar] = useState(false);
  const changeBackground = () => {
    if (window.scrollY >= 80) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };
  let totalQuantity = 0;
  for (const product of cartState.products) {
    totalQuantity += product.quantity;
  }
  const handleBookHomeCollection = () => {
    // Check if the element exists before scrolling
    const homeCollectionData = document.getElementById("Home-Collection-data");
    if (homeCollectionData) {
      setIsMenuOpen(false);
      homeCollectionData.scrollIntoView({
        behavior: "smooth",
      });
    }
  };
  return (
    <header>
      <div className={header ? "header fixed" : "header"}>
        <div className="container">
          <div className="row align-items-center justify-content-sm-between justify-content-end">
            <div className="col-lg-1 col-md-2 col-sm-2  col-3">
              <div
                className="logo"
                data-aos="fade"
                data-aos-once="true"
                data-aos-duration="500"
              >
                <Link to="/">
                  <Logo />
                </Link>
              </div>
            </div>
            <div className="col-lg-11 col-md-10 col-sm-10  col-9">
              <div className="d-flex align-items-center  __menus">
                <div
                  className={
                    showSearchBar
                      ? " headersearchbox mx-md-2 enquireform"
                      : "headersearchbox mx-2 enquireform"
                  }
                >
                  {/* {!showSearchBar ? <SearchBar /> : null} */}
                  <div className="desktop_nav_search ">
                    <SearchBar />
                  </div>
                </div>
                <div className="mobile_nav_search position-relative d-flex  d-sm-none align-items-end ">
                  <MobileSearchBar />
                  {cartState.products.length !== 0 && (
                    <Badge
                      badgeContent={totalQuantity <= 10 ? totalQuantity : "9+"}
                      color="error"
                    >
                      <PiShoppingCartSimple
                        onClick={() => cartDispatch({ type: "TOGGLE_CART" })}
                      />
                    </Badge>
                  )}
                </div>
                <div
                  className="upload_btn_sc "
                  data-aos="fade"
                  data-aos-once="true"
                  data-aos-duration="500"
                >
                  <div
                    className="upload_btn"
                    to="#"
                    onClick={() => cartDispatch({ type: "TOGGLE_UPLOD_FORM" })}
                  >
                    <div
                      className="upload_btn_cnt"
                      style={{
                        background:
                          "linear-gradient(223.23deg, #FFFFFF -39.74%, #DBF5F9 94.44%)",
                      }}
                    >
                      <Upload />
                    </div>
                    <p>Upload Prescription</p>
                  </div>
                  <Link
                    className="upload_btn"
                    to="https://patient-in.creliohealth.com/patient/login"
                    target="_blank"
                  >
                    <div
                      className="upload_btn_cnt"
                      style={{
                        background:
                          "linear-gradient(223.23deg, #FFFFFF -39.74%, #DBF5F9 94.44%)",
                      }}
                    >
                      <Download />
                    </div>
                    <p>Download Reports</p>
                  </Link>
                  <Link className="upload_btn mr-adj" to="/packages">
                    <div
                      className="upload_btn_cnt"
                      style={{
                        background: "#F9E0DB",
                      }}
                    >
                      <AddPackages />
                    </div>
                    <p>Health Packages</p>
                  </Link>
                  {/* <Link
                    className="upload_btn"
                    to="https://patient-in.creliohealth.com/patient/login"
                    target="_blank"
                  >
                    <div
                      className="upload_btn_cnt user"
                      style={{
                        background: "#f4e0e7",
                      }}
                    >
                      <LuUser />
                    </div>
                  </Link>
                  <MyCart /> */}
                </div>
                <div className="navbar p-0 m-0 align-items-end ">
                  <div className="d-none d-sm-flex justify-content-center align-items-center  navbar_item">
                    <div
                      className=" d-flex align-items-center flex-row justify-content-center "
                      data-aos="fade"
                      data-aos-once="true"
                      data-aos-duration="600"
                    >
                      <div className="nah_logo">
                        <Nabh />
                      </div>

                      <div className="homecollection float-start d-grid">
                        <span className="text-black">Home Collection</span>
                        <article>
                          <Link to="tel:01814667555">0181-4667555</Link>
                        </article>
                      </div>
                    </div>
                  </div>
                  <div className="menustn">
                    <div className={hamburgerClasses} onClick={toggleMenu}>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                    <div className={menuClasses}>
                      <div className="_layer"></div>
                      <div className="container">
                        <div className="row">
                          <div className="web-container ">
                            <div className="justify-content-between d-flex col-lg-10 col-12 mx-auto">
                              <div className="header_columns">
                                {/* <div className="footercolumn">
                                  <div className="fheading">
                                    <article
                                      className="text-uppercase" >
                                      <Link to="/">Home</Link>
                                    </article>
                                  </div>
                                </div> */}
                                <div className="footercolumn">
                                  <div className="fheading">
                                    <article className="text-uppercase">
                                      <Link to="/about-us">ABOUT US</Link>
                                    </article>
                                  </div>
                                </div>

                                <div className="footercolumn">
                                  <div className="fheading">
                                    <article className="text-uppercase">
                                      <Link to="/doctors">OUR DOCTORS</Link>
                                    </article>
                                  </div>
                                  <div className="fmenu">
                                    <ul className="p-0 m-0">
                                      <li>
                                        <Link to="/doctors/dr-sanjay-wadhwa">
                                          DR. SANJAY WADHWA
                                        </Link>
                                      </li>
                                      <li>
                                        <Link to="/doctors/dr-lovely-razdan">
                                          DR. LOVELY RAZDAN
                                        </Link>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                                <div className="footercolumn">
                                  <div className="fheading">
                                    <article className="text-uppercase">
                                      <Link to="#">Bookings</Link>
                                    </article>
                                  </div>
                                  <div className="fmenu">
                                    <ul className="p-0 m-0">
                                      <li>
                                        <Link to="/all-test">BOOK A TEST</Link>
                                      </li>
                                      <li>
                                        <Link to="/packages">
                                          BOOK A PACKAGE
                                        </Link>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                                <div className="footercolumn">
                                  <div className="fheading">
                                    <article className="text-uppercase">
                                      SERVICES
                                    </article>
                                  </div>
                                  <div className="fmenu">
                                    <ul className="p-0 m-0">
                                      <li>HOME SAMPLE COLLECTION</li>
                                      <li>
                                        <Link to="/pharmacy">MEDICINES</Link>
                                      </li>
                                      <li>X-RAY</li>
                                    </ul>
                                  </div>
                                </div>

                                <div className="footercolumn">
                                  <div className="fheading">
                                    <article className="text-uppercase">
                                      MY ACCOUNT
                                    </article>
                                  </div>
                                  <div className="fmenu">
                                    <ul className="p-0 m-0">
                                      <li
                                        onClick={() =>
                                          cartDispatch({ type: "TOGGLE_CART" })
                                        }
                                      >
                                        MY CART
                                      </li>
                                      <li>BLOG</li>
                                      <li>
                                        <Link
                                          to="https://patient-in.creliohealth.com/patient/login"
                                          target="_blank"
                                          rel="none"
                                          className="text-black"
                                        >
                                          LOGIN
                                        </Link>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                                <div className="footercolumn">
                                  <div className="fheading">
                                    <article className="text-uppercase">
                                      <Link
                                        className="text-black"
                                        to="/terms-conditions"
                                      >
                                        TERMS & CONDITIONS
                                      </Link>
                                    </article>
                                  </div>
                                </div>
                                <div className="footercolumn">
                                  <div className="fheading">
                                    <article className="text-uppercase">
                                      <Link
                                        className="text-black"
                                        to="/privacy-policy"
                                      >
                                        PRIVACY POLICY
                                      </Link>
                                    </article>
                                  </div>
                                </div>
                                <div className="footercolumn">
                                  <div className="fheading">
                                    <article className="text-uppercase">
                                      <Link
                                        className="text-black"
                                        to="/refund-cancellation"
                                      >
                                        REFUND & CANCELLATION
                                      </Link>
                                    </article>
                                  </div>
                                </div>
                              </div>
                              <div
                                className=" _header_nav_ contact_detail d-none d-md-flex"
                                data-aos="fade-in"
                                data-aos-duration={600}
                                data-aos-once="true"
                                data-aos-easing="ease-in"
                              >
                                <div className="contact">
                                  <a to="tel:01814667555">
                                    <span className="flex-center align-items-start gap-2 sm-gap-4">
                                      <strong>T</strong>
                                      0181-4667555
                                    </span>
                                  </a>
                                </div>
                                <div className="">
                                  <div className="contact">
                                    <a to="mailto:assurepathlabs@gmail.com">
                                      <span className="flex-center align-items-start gap-2 sm-gap-4">
                                        <strong>E</strong>
                                        assurepathlabs@gmail.com
                                      </span>
                                    </a>
                                  </div>
                                </div>
                                <div className=" ">
                                  <div className="contact">
                                    <span className="flex-center align-items-start gap-2 gap-sm-0">
                                      <strong>A </strong>
                                      &nbsp;77, Urban Estate
                                      <br /> Phase-II, Jalandhar
                                    </span>
                                  </div>
                                </div>
                                <div className="col-12  mx-auto  flex-center ">
                                  <Link
                                    to="/"
                                    className="button button--aylen button--round-l footer_btn button--text-thick text-uppercase gradient justify-content-start"
                                    onClick={handleBookHomeCollection}
                                  >
                                    BOOK HOME COLLECTION
                                  </Link>
                                </div>

                                {/* <strong className="haeader_folow-us">
                                  Follow us
                                </strong> */}
                                <div className="socail_icon mt-3">
                                  <div className="">
                                    <Link
                                      to="https://www.facebook.com/assurepathlabsjalandhar/"
                                      target="_blank"
                                    >
                                      <Facebook />
                                    </Link>
                                  </div>
                                  <div className="">
                                    <Link
                                      to="https://www.instagram.com/assurepathlabs/"
                                      target="_blank"
                                    >
                                      <Instagram />
                                    </Link>
                                  </div>

                                  <div className="">
                                    <Link
                                      to="https://www.linkedin.com/company/assurepathlabs/"
                                      target="_blank"
                                    >
                                      <LinkedIn />
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
